export default __webpack_public_path__ + "static/media/lightbulb.a3a07a67.svg";